import type { clientTypes } from '@bedc/client/types';

export const environment: clientTypes.environment.Type = {
	name: 'carters-prod',

	aws: {
		chime: {
			appInstanceArn: import.meta.env.VITE_CHIME_APP_INSTANCE_ARN ?? '',
		},
		cognito: {
			region: import.meta.env.VITE_COGNITO_REGION ?? '',
			userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
			userPoolWebClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID ?? '',
			identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID ?? '',
			customDomain: import.meta.env.VITE_COGNITO_CUSTOM_DOMAIN ?? '',
		},
	},

	error: {
		reloadOn501: true,
	},

	google: {
		analytics: {
			trackingIds: import.meta.env.VITE_GOOGLE_ANALYTICS_TRACKING_IDS ?? '',
		},
	},

	posthog: {
		token: import.meta.env.VITE_POST_HOG_TOKEN ?? '',
		debug: false,
		sessionRecording: true,
	},

	path: {
		api: import.meta.env.VITE_PATH_API ?? '',
		websocket: import.meta.env.VITE_PATH_WEBSOCKET ?? '',
	},

	sentry: {
		enabled: true,
		dsn: import.meta.env.VITE_SENTRY_DSN_CLIENT ?? '',
		sampleRate: 1.0,
		tracesSampleRate: 0.5,
		replaysSessionSampleRate: 0.5,
		replaysOnErrorSampleRate: 1.0,
	},

	webPush: {
		publicKey: import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY ?? '',
	},
};
